/**
 * Cart-drawer friend-referral "extra 10% off" form.
 *
 * Shows the form (rendered hidden by snippets/cart-drawer-friend-offer.liquid)
 * when localStorage has isc_friend_code (set in theme.liquid for visitors who
 * arrived at /apps/gwp/welcome with a FRIEND-* code).
 *
 * On submit:
 *   1. Subscribes the email to Klaviyo list YuWFjc (master Newsletter, WeJC23).
 *   2. Identifies the visitor in onsite Klaviyo so subsequent events are tied.
 *   3. POSTs /cart/update.js with attribute friend_redeemed=1 so the form is
 *      not re-rendered on subsequent drawer refreshes.
 *   4. GETs /discount/WELCOME10 to apply the 10% off code (combines with the
 *      GWP product discount because the code is configured to stack).
 *   5. Dispatches theme:cart:change without _cartDrawerOrigin so cart-drawer.js
 *      runs refreshCartDrawer() and re-renders the line items section.
 */
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'WeJC23';
  var KLAVIYO_LIST_ID = 'YuWFjc';
  var KLAVIYO_REVISION = '2024-10-15';
  var DISCOUNT_CODE = 'WELCOME10';

  function getFriendCode() {
    try { return localStorage.getItem('isc_friend_code') || ''; } catch (e) { return ''; }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function syncVisibility() {
    var offer = document.querySelector('[data-friend-offer]');
    if (!offer) return;
    if (getFriendCode()) {
      offer.removeAttribute('hidden');
    } else {
      offer.setAttribute('hidden', '');
    }
  }

  function subscribeKlaviyo(email) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'iS Clinical Friend Referral (cart drawer)',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { friend_code: getFriendCode() || null },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: KLAVIYO_LIST_ID } },
        },
      },
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify(payload),
      mode: 'cors',
    }).then(function (res) {
      if (!res.ok && res.status !== 202) {
        throw new Error('Klaviyo subscribe failed (' + res.status + ')');
      }
    });
  }

  function identifyOnsite(email) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { $email: email, friend_code: getFriendCode() || null }]);
    } catch (e) {}
  }

  function setCartAttribute() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { friend_redeemed: '1' } }),
    });
  }

  function applyDiscount() {
    // Hitting /discount/CODE sets the discount cookie and applies it to the
    // current cart. We don't need the redirected HTML, so fetch + discard.
    return fetch('/discount/' + DISCOUNT_CODE, { credentials: 'same-origin' });
  }

  function refreshDrawer() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true,
          })
        );
      })
      .catch(function () {});
  }

  function setMessage(state, text) {
    var msgEl = document.querySelector('[data-friend-offer-message]');
    if (!msgEl) return;
    if (state) msgEl.setAttribute('data-state', state); else msgEl.removeAttribute('data-state');
    msgEl.textContent = text || '';
  }

  function setLoading(form, loading) {
    var btn = form.querySelector('[data-friend-offer-submit]');
    var spinner = form.querySelector('[data-friend-offer-spinner]');
    var label = form.querySelector('[data-friend-offer-label]');
    if (!btn) return;
    btn.disabled = !!loading;
    if (spinner) { if (loading) spinner.removeAttribute('hidden'); else spinner.setAttribute('hidden', ''); }
    if (label) label.textContent = loading ? 'Applying…' : 'Apply 10% off';
  }

  function handleSubmit(event) {
    var form = event.target.closest('[data-friend-offer-form]');
    if (!form) return;
    event.preventDefault();

    var emailField = form.querySelector('[data-friend-offer-email]');
    var email = emailField ? emailField.value.trim() : '';

    if (!isValidEmail(email)) {
      setMessage('error', 'Please enter a valid email.');
      if (emailField) emailField.focus();
      return;
    }

    setMessage(null, '');
    setLoading(form, true);

    identifyOnsite(email);

    subscribeKlaviyo(email)
      .then(setCartAttribute)
      .then(applyDiscount)
      .then(function () {
        setMessage('success', '10% off applied. Welcome to iS Clinical.');
        return refreshDrawer();
      })
      .catch(function (err) {
        console.error('[FriendOffer]', err);
        setMessage('error', 'Something went wrong. Please try again.');
        setLoading(form, false);
      });
  }

  function init() {
    syncVisibility();
    // Re-sync after every cart change (cart-drawer.js swaps the line-items section).
    document.addEventListener('theme:cart:change', function () {
      // Defer to allow innerHTML swap to settle.
      setTimeout(syncVisibility, 0);
    });
    document.addEventListener('submit', handleSubmit);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
